// Modules
import React, { useContext } from "react";

// Context
import ApiContext from "../../contexts/ApiContext";

// Local
import config from "../../config/environment";
import LogoLink from "../utils/LogoLink";

// Assets
import SocialNetworkLink from "../utils/SocialNetworkLink";
import FacebookLogo from "../../assets/img/svg/Facebook";
import LinkedInLogo from "../../assets/img/svg/LinkedIn";
import YouTubeLogo from "../../assets/img/svg/YouTube";
import InstagramLogo from "../../assets/img/svg/Instagram";
import "./footer.scss";

const Footer = () => {
	const { isMobile, isTablet } = useContext(ApiContext);

	return (
		<div className={`footer-container ${isMobile === true || isTablet === true ? "mobile" : ""}`}>
			<div className="first-col">
				<LogoLink clssName="logo" type="secondary" />
				<div className="social-networks-wrapper">
					<h4
						className="tagline"
						style={{
							fontFamily: "var(--OpenSansLight)",
							fontSize: "1.7vh",
							display: "inline-block",
							width: "max-content",
							margin: "0",
							marginBottom: "2vh",
						}}
					>
						Suivez l'aventure Bevouac
				</h4>
					<div className="social-networks-container">
						<SocialNetworkLink 
							clssName="facebook-logo"
							img={<FacebookLogo />}
							link={config.SOCIAL_NETWORKS.facebook}
						/>
						<SocialNetworkLink 
							clssName="linkedin-logo"
							img={<LinkedInLogo />}
							link={config.SOCIAL_NETWORKS.linkedin}
						/>
						<SocialNetworkLink 
							clssName="instagram-logo"
							img={<InstagramLogo />}
							link={config.SOCIAL_NETWORKS.instagram}
						/>
						<SocialNetworkLink 
							clssName="youtube-logo"
							img={<YouTubeLogo />}
							link={config.SOCIAL_NETWORKS.youtube}
						/>
					</div>
				</div>
			</div>

			<div className="links-container">
				<div className="second-col">
					<h6>Notre service</h6>
					<a className="link" href="https://www.bevouac.com/service">Service et tarifs</a>
					<a className="link" href="https://aide.bevouac.com/">FAQ</a>
					<a className="link" href="https://www.bevouac.com/agent-immobilier">Proposer un bien</a>
				</div>

				<div className="third-col">
					<h6>Confidentialité</h6>
					<a className="link" href="https://www.bevouac.com/mentions-legales">Mentions légales</a>
					<a className="link" href="https://www.bevouac.com/confidentialite">Confidentialité</a>
					<a className="link" href="https://www.bevouac.com/cgu">CGU</a>
				</div>

				<div className="fourth-col">
					<h6>À propos de Bevouac</h6>
					<a className="link" href="https://www.bevouac.com/notre-histoire">Notre histoire</a>
					<a className="link" href="https://www.bevouac.com/presse">Espace presse</a>
					<a className="link" href="https://www.bevouac.com/nous-rejoindre">Recrutement - Nous rejoindre</a>
					<a className="link" href="https://www.bevouac.com/contact">Contact</a>
					<a className="link" href="https://bevouac.typeform.com/to/Fz5wI7">S'abonner à notre newsletter</a>
				</div>

				<div className="fifth-col">
					<h6>Analyse data</h6>
					<a className="link" href="https://www.bevouac.com/comparatif">Où investir ?</a>
					<a className="link" href="https://www.bevouac.com/lille-investissement-locatif">Lille</a>
					<a className="link" href="https://www.bevouac.com/marseille-investissement-locatif">Marseille</a>
					<a className="link" href="https://www.bevouac.com/nancy-investissement-locatif">Nancy</a>
					<a className="link" href="https://www.bevouac.com/lyon-investissement-locatif">Lyon</a>
					<a className="link" href="https://www.bevouac.com/rennes-investissement-locatif">Rennes</a>
					<a className="link" href="https://www.bevouac.com/le-havre-investissement-locatif">Le Havre</a>
					<a className="link" href="https://www.bevouac.com/nantes-investissement-locatif">Nantes</a>
					
				</div>
			</div>
			
		</div>
	);
};

export default Footer;